import { ArrayQ } from "@pdfking/structs"

import { Keys } from "./Keys"

/**
 * Counts the entries of an array or the own enumerable keys of a record.
 *
 * @param value - Array or record to measure
 * @returns Number of entries
 *
 * @example
 * ```ts
 * import { Length } from "@pdfking/tfunc"
 *
 * Length([1, 2, 3]) // 3
 * Length({ a: 2, b: 3 }) // 2
 * Length({}) // 0
 * ```
 */
export const Length = (value: object): number => (ArrayQ(value) ? value.length : Keys(value).length)
